import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSharedModule } from '../shared.module';
import { SmartActionsModule } from 'src/app/components/smart-actions/smart-actions.module';
import { AppSearchBarComponent } from './app-search-bar.component';
import { AppSearchBarService } from './app-search-bar.service';

@NgModule({
  declarations: [AppSearchBarComponent],
  imports: [
        CommonModule,
        SmartActionsModule,
        AppSharedModule
    ],
    exports: [
        AppSearchBarComponent
    ],
    providers: [
        AppSearchBarService
    ]
})
export class AppSearchBarModule { }
